import { useEffect, useState } from 'react';

export const useIsTinyScreen = () => {
  const [width, setWidth] = useState(0);
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
    setWidth(window?.screen?.width ?? 0);
  }, []);

  // Возвращаем false на сервере, чтобы избежать гидратации
  if (!isClient) {
    return false;
  }

  return width <= 352;
};
